<div class="container px-3" data-component="contact-us" data-module="contact_us" data-view="index">
  <div class="contactUs pr-0">
    <div class="contactUsDropDownMenu">
      <div class="contactUsDropdown">
        <!-- label for contact us -->
        <h2>
          <!--<small [innerHTML]="contactus?.copy$$header_contact?.TEXT"></small>-->
          <label class="ContactUsHead" for="footerSec" [innerHTML]="contactus?.copy$$header_contact?.TEXT" id="ContactUsHead1"> </label> 
          <span *ngIf="numOfProducts() <= 1 && brandId==='mil' && (contactus?.copy$$enable_MIL?.TEXT === 'true') ; else contactUsCardName" class="partnerContactusHeader"
            [innerHTML]="contactus?.copy$$installment_loan_account_name?.TEXT"></span>
          <ng-template #contactUsCardName>
            <span *ngIf="numOfProducts() <= 1" class="partnerContactusHeader"
            [innerHTML]="contactus?.copy$$header_card_program_name?.TEXT"></span>
          </ng-template>
        </h2>

          <div class="select-wrapper" #selectWrapper attr.data-isopened="{{toggleState}}" *ngIf="numOfProducts() > 1" >
            <select class="dropdown12" #select aria-labelledby="DDSelected" attr.aria-disabled="{{disabled}}" attr.data-dropdown-sc-name="{{dropdownSCName}}" (click)="toggleList()" attr.aria-expanded="{{isOpened}}" aria-haspopup="true" attr.data-isopened="{{toggleState}}" 
              (change)="selectedProduct($event.target.value)" id="footerSec" [attr.aria-labelledby]="contactus?.copy$$header_card_program_name?.WCAG_TEXT"  >
              <option *ngFor="let product of productArray" [value]="product.card_program_name" [innerHTML]="product.card_program_name" class="list-group-item productList">

              </option>
            </select>
          </div>
      </div>
    </div>
    <div class="contactUSPhoneAddress">
      <div class="row m-0">
        <div class="phoneDetails">
          <div class="">
            <div class="cta-container">
              <section class="cta" *ngIf="isSendMessageSectionEnabled()">
                <section data-help-button="chat" *ngIf="isLiveEngageChat" class="liveEngageChat off">
                  <div>
                    <p [innerHTML]="
                        contactus?.copy$$label_chat_with_an_associate?.TEXT
                      "></p>
                    <a href="#" class="ui-link" [innerHTML]="contactus?.copy$$link_chat_now_?.TEXT"></a>
                  </div>
                </section>
                <section class="send_message">
                  <div>
                    <p [innerHTML]="
                        contactus?.copy$$label_send_secure_message?.TEXT
                      "></p>
                    <a href="{{ globalData?.redirectURL }}#newsecuremessage" class="hash_change ui-link"
                      [innerHTML]="contactus?.copy$$link_send_now?.TEXT"></a>
                  </div>
                </section>
                <!-- <a href="#external_partner_site" data-partner-link="" class="ui-link" [innerHTML]="contactus?.copy$$link_sign_on_contact_us.TEXT"></a>
                      <a href="#" data-partner-link="" class="ui-link" >Sign on to your U.S. Commercial Revolving Account Online TBD</a> -->
              </section>
            </div>
            <div class="phone-container">
              <section class="phone">
                <div class="lg-view-ds">
                  <h3 id="contact_us_phone" class="visuallyhidden" [innerHTML]="
                      contactus?.copy$$ada_contact_us_by_phone?.WCAG_TEXT
                    "></h3>
                  <p>
                    <em [innerHTML]="
                        cmsConfig?.customer_service_phone_number
                      "></em>
                  </p>
                  <p class="workDaysHolder" 
                  [innerHTML]="isTHDAccnt()? cmsConfig?.customer_service_hours_of_operation : contactus?.copy$$info_customer_service_hours_of_operation?.TEXT"></p>
                  
                  <h4 (click)="toggle_phone()" [className]="switch_phone" [innerHTML]="
                      contactus?.copy$$header_additional_numbers?.TEXT
                    "></h4>
                  <dl id="phone_1" [className]="class_phone" class="show-container">
                    <dt [innerHTML]="
                        contactus?.copy$$header_technical_assistance?.TEXT
                      ">
                      <br />
                    </dt>
                    <dd [innerHTML]="
                        cmsConfig?.technical_assistance_phone_number
                      "></dd>
                    <dt [innerHTML]="
                        contactus?.copy$$header_TDD_TTY_for_the_hearing_impaired
                          ?.TEXT
                      ">
                      <br />
                    </dt>
                    <dd [innerHTML]="cmsConfig?.TDD_TYY_for_the_hearing_impaired"></dd>
                    <dt [innerHTML]="
                        contactus
                          ?.copy$$header_outside_the_us_canada_and_puerto_rico
                          ?.TEXT
                      ">
                      <br />
                    </dt>
                    <dd [innerHTML]="
                        cmsConfig?.outside_the_US_canada_and_puerto_rico
                      "></dd>
                  </dl>
                </div>
              </section>
            </div>
          </div>
        </div>
        <div class="addressDetails">
          <section class="addresses">
            <div>
              <p [innerHTML]="cmsConfig?.card_program_name"></p>
              <p class="poBoxHolder" [innerHTML]="isCPAYTHDAccnt()? cmsConfig?.general_correspondance_mailing_address : contactus?.copy$$info_general_correspondance_mailing_address?.TEXT"></p>
              <h3 class="visuallyhidden" [innerHTML]="contactus?.copy$$ada_contact_us_by_mail?.WCAG_TEXT"></h3>
              <h4 (click)="toggle_address()" [className]="switch_address"
                [innerHTML]="contactus?.copy$$label_payment_address?.TEXT"></h4>
              <div id="addresses_1" [className]="class_address">
                <span [innerHTML]="cmsConfig?.regular_payments_mailing_address"></span>
                <span [innerHTML]="cmsConfig?.overnight_delivery_express_payments"></span>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div *ngIf="!isCPAYAccount" role="img" [attr.aria-label]="contactus?.copy$$footer_citi_label?.WCAG_TEXT"  class="citi_icon">
      </div> 
    </div>
  </div>
</div>
